(() => {
  const section = document.querySelector('[data-section-type="header"]');
  const wrapper = section?.closest('.shopify-section');
  if (!wrapper) return;

  const THRESHOLD = 80;
  const DELTA = 4;
  const root = document.documentElement;
  const nav = wrapper.querySelector('.nav-bar');
  const searchWrapper = wrapper.querySelector('.header__search-bar-wrapper');
  const desktop = window.matchMedia('(min-width: 1000px)');

  let hidden = false;
  let lastY = window.scrollY;
  let ticking = false;

  // Desktop mega panels hang off the nav bar, so they line up while hidden. Revealing would slide the nav bar out from under the cursor and close the menu.
  const needsHeader = () =>
    root.classList.contains('rbx-sp-locked') ||
    root.classList.contains('rbx-mega-locked') ||
    !!searchWrapper?.classList.contains('is-fixed') ||
    !!searchWrapper?.classList.contains('rbx-sb-open') ||
    !!wrapper.querySelector(desktop.matches ? '[aria-expanded="true"]:not([data-rbx-mega-trigger])' : '[aria-expanded="true"]');

  const busy = () => needsHeader() || !!wrapper.querySelector('[aria-expanded="true"]');

  const hide = () => {
    if (hidden) return;
    const distance = nav
      ? nav.getBoundingClientRect().top - wrapper.getBoundingClientRect().top
      : wrapper.offsetHeight;
    wrapper.style.setProperty('--rbx-header-retract', `${distance}px`);
    wrapper.classList.add('rbx-header-hidden');
    hidden = true;
  };

  const show = (instant) => {
    if (!hidden) return;
    if (instant) wrapper.classList.add('rbx-header-instant');
    wrapper.classList.remove('rbx-header-hidden');
    hidden = false;
    if (instant) {
      void wrapper.offsetHeight;
      wrapper.classList.remove('rbx-header-instant');
    }
  };

  const update = () => {
    ticking = false;
    const y = Math.max(0, window.scrollY);
    const dy = y - lastY;
    if (y <= THRESHOLD) {
      show();
    } else if (Math.abs(dy) > DELTA) {
      if (dy < 0) show();
      else if (!busy()) hide();
    } else {
      return;
    }
    lastY = y;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  // Overlays opened from the header measure their position as they open, so it has to be back in place first.
  const observer = new MutationObserver(() => needsHeader() && show());
  observer.observe(wrapper, { subtree: true, attributeFilter: ['aria-expanded'] });
  observer.observe(root, { attributeFilter: ['class'] });
  if (searchWrapper) observer.observe(searchWrapper, { attributeFilter: ['class'] });

  // The nav bar sheet below 1000px and the phone search row read the header position synchronously on click, before any observer runs.
  const preempt = (event) => {
    if (hidden && !desktop.matches && event.target.closest?.('[data-rbx-mega-trigger], [data-action="toggle-search"]')) show(true);
  };
  document.addEventListener('click', preempt, true);
  document.addEventListener('keydown', preempt, true);

  wrapper.addEventListener('focusin', (event) => {
    if (!nav || !nav.contains(event.target)) show();
  });
})();
